import { cancelTokenFromSignal } from '../../../utils/axios.utils';
import { restApi } from '../../api';
import {
  ApproveRachelAgentRunParams,
  FindRachelChatsOutput,
  FindRachelChatsParams,
  RachelActiveContextOutput,
  RachelChatMessagesOutput,
  RachelChatOutput,
  RachelMessageFeedbackOutput,
  RenameRachelChatParams,
  SetRachelChatToolApprovalParams,
  SetRachelMessageFeedbackParams,
} from './rachelChats.types';

const PATH = 'rachel/chats';

export const createRachelChat = () => restApi.post<RachelChatOutput>(PATH);

export const findRachelChats = (params?: FindRachelChatsParams, signal?: AbortSignal) =>
  restApi.get<FindRachelChatsOutput>(PATH, params, {
    cancelToken: cancelTokenFromSignal(signal)?.token,
  });

export const getRachelChat = (chatId: string) => restApi.get<RachelChatOutput>(`${PATH}/${chatId}`);

export const getRachelChatMessages = (chatId: string) =>
  restApi.get<RachelChatMessagesOutput>(`${PATH}/${chatId}/messages`);

export const getRachelActiveContext = (chatId: string) =>
  restApi.get<RachelActiveContextOutput | null>(`${PATH}/${chatId}/active-context`);

export const setRachelActiveContext = (chatId: string, context: RachelActiveContextOutput) =>
  restApi.put<RachelActiveContextOutput>(`${PATH}/${chatId}/active-context`, context);

export const clearRachelActiveContext = (chatId: string) =>
  restApi.delete<void>(`${PATH}/${chatId}/active-context`);

export const abortRachelTurn = (chatId: string) => restApi.delete<void>(`${PATH}/${chatId}/abort`);

export const deleteRachelChat = (chatId: string) => restApi.delete<void>(`${PATH}/${chatId}`);

export const renameRachelChat = ({ chatId, title }: RenameRachelChatParams) =>
  restApi.patch<void>(`${PATH}/${chatId}/title`, { title });

export const setRachelChatToolApproval = ({
  chatId,
  toolName,
  yoloMode,
}: SetRachelChatToolApprovalParams) =>
  restApi.patch<void>(`${PATH}/${chatId}/tool-approvals`, { toolName, yoloMode });

export const approveRachelAgentRun = ({
  chatId,
  approvalId,
  approved,
}: ApproveRachelAgentRunParams) =>
  restApi.patch<void>(`${PATH}/${chatId}/agent-approvals/${approvalId}`, { approved });

export const setRachelMessageFeedback = ({
  chatId,
  messageId,
  rating,
  comment,
  problemType,
}: SetRachelMessageFeedbackParams) =>
  restApi.post<void>(`${PATH}/${chatId}/messages/${messageId}/feedback`, {
    rating,
    comment,
    problemType,
  });

export const getRachelChatFeedback = (chatId: string) =>
  restApi.get<RachelMessageFeedbackOutput[]>(`${PATH}/${chatId}/feedback`);
